var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Identicon',{attrs:{"size":"128","value":"5F1aGzHi5uJkRdegzBNj4fhG81ZtrWS79TrErTa7qL7ih4ik","theme":"beachball"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }